import React from 'react';
import { Link } from 'react-router-dom';

import clx from 'classnames';

import styles from './LayoutNavLink.module.scss';

interface LayoutNavLinkProps {
    external?: boolean;
    icon?: React.JSX.Element;
    isActive?: boolean;
    label: string;
    to: string;
}

export const LayoutNavLink = ({ external, icon, isActive, label, to }: LayoutNavLinkProps) => {
    if (external) {
        return (
            <a
                className={clx(styles.layoutNavLink, isActive && styles.layoutNavLink_active)}
                href={to}
                rel="noopener noreferrer"
            >
                {icon && <span className={styles.layoutNavLink__icon}>{icon}</span>}
                {label}
            </a>
        );
    }
    return (
        <Link className={clx(styles.layoutNavLink, isActive && styles.layoutNavLink_active)} to={to}>
            {icon && <span className={styles.layoutNavLink__icon}>{icon}</span>}
            {label}
        </Link>
    );
};
